<template>
    <v-card
        style="min-width: 100%; padding: 1rem"
        v-if="rol == 1 || rol == 2 || rol == 9"
    >
        <v-row>
            <h3>Formas de pago</h3>
            <v-col cols="12">
                <multiple-select
                    :readonly="readonly"
                    :headers="headers_metodos"
                    title=""
                    :elementos="metodos_pago"
                    @create="createAgente"
                    @delete="deleteAgentes"
                    @getEstado="updateAgentesS"
                    @update="updateAgentes"
                >
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="metodo.id_metodo"
                                :items="metodos"
                                item-text="nombre"
                                item-value="id"
                                label="Método"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <div style="display: flex">
                                <v-text-field
                                    type="number"
                                    v-model="metodo.monto"
                                    label="Porcentaje"
                                >
                                </v-text-field>
                                <v-btn-toggle
                                    color="primary"
                                    shaped
                                    v-model="metodo.id_tipo_dcto"
                                    background-color="white"
                                >
                                    <v-btn text>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-btn>
                                    <v-btn text>
                                        <v-icon>mdi-currency-eur</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>
                    </v-row>
                </multiple-select>
            </v-col>
        </v-row>
        <v-card>
            <v-row>
                <v-col cols="4">
                    <h4>Total:</h4>
                </v-col>
                <v-col cols="4">
                    <h4 class="text-center" :style="totalPorcentaje != 100 ? 'color:red' : ''">
                        {{ formatNumber(totalPorcentaje) }}
                        %
                    </h4>
                </v-col>
                <v-col cols="4">
                    <h4 class="text-center">{{ totalMetodoPago | format_precio }}</h4>  
                </v-col>
            </v-row>
        </v-card>
    </v-card>
</template>
<script>
export default {
    props: ["value", "readonly", "presupuesto", "facturas"],
    data() {
        return {
            metodo: {
                id_tipo_dcto: 0,
            },
            total: 0,
            metodos_pago: [],
        };
    },
    created() {
        if (this.presupuesto.id != null) {
            this.getAttributesMetodoTable();
        }
        if (this.value != null) {
            this.metodos_pago = this.value;
            this.updateMetodos();
        }
    },
    methods: {
        formatNumber(number) {
            return Number.parseFloat((number ?? 0).toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
        create() {
            if (this.metodos_pago == null) {
                this.metodos_pago = [];
            } else {
                this.updateMetodos();
            }
        },
        updateMetodos() {
            if (this.presupuesto != null) {
                this.metodos_pago.forEach((element) => {
                    // let subtotal = this.formatNumber(this.calcularSubTotal());
                    // console.log("metodos de pago");
                    if (element.id_tipo_dcto == 1) {
                        if (element.id_metodo == 3) {
                            element.total = element.monto;
                            console.log("siva");
                            element.porcentaje = parseFloat(
                                (
                                    (element.monto / this.presupuesto.total) *
                                    100 *
                                    (1 + this.presupuesto.iva / 100)
                                ).toFixed(2)
                            );
                        } else {
                            element.total = element.monto;
                            element.porcentaje = parseFloat(
                                (
                                    (element.monto / this.presupuesto.total) *
                                    100
                                ).toFixed(2)
                            );
                        }
                    } else {
                        element.total =
                            (parseFloat(this.presupuesto.total) *
                                parseFloat(element.monto)) /
                            100;
                        element.porcentaje = element.monto;
                        if (element.id_metodo == 3) {
                            element.total /= 1 + this.presupuesto.iva / 100;
                        }
                    }
                });
                this.total = 1;
                this.total = 0;
            }
        },
        updateAgentesS(index) {
            //console.log(index);
            this.metodo = JSON.parse(JSON.stringify(this.metodos_pago[index]));
            this.index = index;
        },
        //metodos
        deleteAgentes(indexo) {
            this.metodos_pago.splice(indexo, 1);
        },
        createAgente() {
            //console.log(this.metodo.id_metodo);
            this.metodos_pago.push({
                id: null,
                id_metodo: this.metodo.id_metodo,
                monto: this.metodo.monto,
                id_tipo_dcto: this.metodo.id_tipo_dcto,
                metodo: JSON.parse(
                    JSON.stringify(
                        this.metodos.find(
                            (element) => element.id == this.metodo.id_metodo
                        )
                    )
                ),
                total: 0,
                facturado: 0,
                pagado: 0,
                pendiente: 0,
            });
            this.metodo = {
                id_tipo_dcto: 0,
            };
        },

        updateAgentes() {
            this.metodos_pago[this.index].id_metodo = this.metodo.id_metodo;
            this.metodos_pago[this.index].monto = this.metodo.monto;
            this.metodos_pago[this.index].id_tipo_dcto =
                this.metodo.id_tipo_dcto;
            (this.metodos_pago[this.index].metodo = JSON.parse(
                JSON.stringify(
                    this.metodos.find(
                        (element) => element.id == this.metodo.id_metodo
                    )
                )
            )),
                (this.metodo = { id_tipo_dcto: 0 });
            this.updateMetodos();
        },

        getAttributesMetodoTable() {
            const id_presupuesto = this.presupuesto.id;
            axios
                .get(
                    `api/get-attributes-metodo-presupuesto?id_presupuesto=${id_presupuesto}`
                )
                .then(
                    (res) => {
                        const response = res.data.success;
                        // for(let i = 0; i < this.metodos_pago; i++){
                        //     this.metodos_pago[i]
                        // }
                        this.metodos_pago.forEach((element) => {
                            if (element.id_metodo == 3) {
                                element.facturado =
                                    response.metodo_nota.facturado;
                                element.pagado = response.metodo_nota.pagado;
                            } else {
                                element.facturado =
                                    response.metodo_factura.facturado;
                                element.pagado = response.metodo_factura.pagado;
                            }
                        });
                        const reset = JSON.parse(
                            JSON.stringify(this.metodos_pago)
                        );
                        this.metodos_pago = [];
                        this.metodos_pago = reset;
                    },
                    (res) => {}
                );
        },
        /*saveFacturas() {
            if (this.facturas != null) {
                console.log('factura', this.facturas);
                console.log('metodos_pago', this.metodos_pago);
                this.metodos_pago.forEach((element) => {
                    let facturado_a = 0;
                    let facturado_b = 0;
                    this.facturas.forEach((element2) => {
                        if (element2.nota == 0) {
                            facturado_a =
                                element.facturado + element2.facturado;
                            element.pagado =
                                element.pagado + element2.abonado;
                            element.facturado = facturado_a;
                        } else {
                            facturado_b =
                                element.facturado + element2.facturado;
                            element.pagado =
                                element.pagado + element2.abonado;
                            element.facturado = facturado_b;
                        }
                    });
                });
            }

        }*/
    },
    watch: {
        metodos_pago(val) {
            this.$emit("input", val ?? []);
        },
        value: {
            deep: false,
            handler(val) {
                this.metodos_pago = val ?? [];
                this.create();
            },
        },

        "presupuesto.total"(val) {
            this.updateMetodos();
        },
        "presupuesto.id"(val) {
            this.getAttributesMetodoTable();
        },
        facturas(val) {
            //this.saveFacturas();
        },
    },
    computed: {
        // Total en porcentaje
        totalPorcentaje() {
            let total = this.total;
            this.metodos_pago.forEach((element) => {
                let per = parseFloat(element.porcentaje);
                total += per;
            });
            this.$emit("total", total);
            return total;
        },
        // Valor del total
        totalMetodoPago() {
            let total = this.total;
            
            this.metodos_pago.forEach((element) => {
                let valor = parseFloat(element.total);
                total += valor;
            });
            return total;
        },
        headers_metodos() {
            let headers_metodos = [
                { text: "Método", value: "metodo.nombre", sortable: false },
                {
                    text: "Porcentaje (%)",
                    value: "porcentaje",
                    sortable: false,
                },
                { text: "Total", value: "total", sortable: false },
                { text: "Facturado", value: "facturado", sortable: false }, // suma de todos los totals de facturas de tipo correspondiente
                { text: "Pagado", value: "pagado", sortable: false }, // suma de todos los abonos pertenecientes a facturas de correspondiente
                { text: "Pendiente", value: "pendiente", sortable: false }, // diff pagado y total
                ...(!this.readonly
                    ? [{ text: "Acciones", value: "action", sortable: false }]
                    : []),
            ];
            if (this.rol != 1 && this.rol != 2) {
                headers_metodos.splice(2, 3);
            }
            return headers_metodos;
        },
        rol() {
            return parseInt(localStorage.getItem("role"));
        },
        metodos() {
            return this.$store.getters.metodos_pago.filter(
                (ele) => ele.id_tipo == 1
            );
        },
    },
};
</script>
